import { Stack, Typography } from '@mui/material'
import { FC, useContext } from 'react'

import { AdvisorSelect } from '../../components/Estimates/AdvisorSelect/AdvisorSelect'
import CloseDate from '../../components/Estimates/CloseDate'
import { CustomerLinkWithNotes } from '../../components/SharedUI/CustomerLinkWithNotes'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'

export const EstimateCustomerAdvisorInfo: FC = () => {
  const { customer, repairOrder } = useContext(RepairOrderContext)

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={1}>
      {customer && (
        <>
          <Stack direction="row" spacing={1}>
            <Typography sx={{ fontWeight: 'bold' }}>Customer:</Typography>
            <CustomerLinkWithNotes customer={customer} />
            <Typography>
              {` - ${
                customer.information!.phone
                  ? customer.information!.phone
                  : customer.information!.email
              }`}
            </Typography>
          </Stack>
          {repairOrder && (
            <Stack direction="row" spacing={1}>
              <Typography sx={{ fontWeight: 'bold' }}>Advisor:</Typography>
              <AdvisorSelect repairOrder={repairOrder.entry!} />
            </Stack>
          )}
          <CloseDate />
        </>
      )}
    </Stack>
  )
}
